import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import { connect } from 'react-redux';
import Link from '../../components/link/internal-link';
import ReactRouterBreadcrumbs from 'react-router-breadcrumbs';
import ArrowIcon from './arrow-icon';
import { getCategories, getCategoryBySlug } from '../../selectors/categories-selectors';
import { getUserBySlug } from '../../selectors/user-selectors';
import { getPostBySlug } from '../../selectors/post-selectors';
import { getForumData } from '../../selectors/forum-data-selectors';
import { getCurrentLocation } from '../../selectors/location-history-selectors';

import withTranslate from '../../hoc/with-translate';
import styles from './breadcrumbs.scss';

const SELECTOR_MAP = {
  ':categorySlug': (state, text) => (getCategoryBySlug(state, text) || {}).label,
  ':userSlug': (state, text) => (getUserBySlug(state, text) || {}).name,
  ':postSlug': (state, text) => (getPostBySlug(state, text) || {}).title,
};

const createSeparator = (crumbElement, index) =>
  <span className={styles.separator} key={`separator-${index}`}>
    <ArrowIcon className="breadcrumbs-icon-fill"/>
  </span>;

const Breadcrumbs = ({ routes, params, state, t, forumData: { label } }) => {
  SELECTOR_MAP['Wix Forum'] = () => label;

  const resolver = (key, text) => {
    const fn = SELECTOR_MAP[key];
    return fn ? fn(state, text) : t(key);
  };

  // eslint-disable-next-line max-params
  const createLink = (link, key, text, index, routes) => {
    const categories = getCategories(state);
    const hasOneCategory = categories.length === 1;
    const length = _.filter(routes, r => !r.breadcrumbIgnore).length;
    const isLast = index === length - 1;
    const isFirst = index === 0;
    const is404 = getCurrentLocation(state).pathname === '/404';
    if (isFirst && hasOneCategory) {
      link = `/${categories[0].slug}`;
    }

    return isLast && !is404 ?
      <span className="breadcrumbs-font" key={key} data-hook="breadcrumbs__current-page">
        {text}
      </span> :
      <Link className="breadcrumbs-font" to={link} key={key} data-hook={`breadcrumbs__${index}`}>
        {text}
      </Link>;
  };

  return (
    <ReactRouterBreadcrumbs
      className={classNames(styles.breadcrumbs, 'breadcrumbs-text-color')}
      routes={routes}
      params={params}
      resolver={resolver}
      createLink={createLink}
      createSeparator={createSeparator}
    />
  );
};

Breadcrumbs.propTypes = {
  routes: PropTypes.array.isRequired,
  params: PropTypes.object.isRequired,
  state: PropTypes.object,
  t: PropTypes.func,
  forumData: PropTypes.object,
};

const mapStateToProps = state => ({
  forumData: getForumData(state),
  state,
});

export default connect(mapStateToProps)(withTranslate(Breadcrumbs));



// WEBPACK FOOTER //
// ./app/components/breadcrumbs/breadcrumbs.js